import React, { useEffect, useState } from "react";

import Swal from "sweetalert2";
import { useTable, useSortBy, usePagination, useFilters } from "react-table";
import { useHistory } from "react-router-dom";

import { FaSortUp, FaSortDown, FaSort } from "react-icons/fa";
import { BsEye, BsThreeDots } from "react-icons/bs";
import { FiEdit, FiPlusCircle } from "react-icons/fi";
import { CgClose } from "react-icons/cg";
import CriancaService from "../../../main/services/CriancaService";

import { Link as ReactLink } from "react-router-dom";

import {
  Flex,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Link,
  Text,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  IconButton,
  Box,
} from "@chakra-ui/react";

import SemRegistros from "../SemRegistros";
import TablePagination from "../TablePagination";
import { isEmptyArray } from "formik";
import {
  criancaFunc,
  Permission,
  servicoAcolhimentoFunc,
  visitasFunc,
} from "../../../helpers/Funcionalidades";
import { CadastrarMovimentacaoModal } from "../../pages/Criancas/Movimentacao/Cadastrar";
import { PrintMenuItemCrianca } from "../PrintMenuItemCrianca";
import LoadingSpinner from "../LoadingSpinner";

export const TableCriancas = (props) => {
  const { data, columns, entidade, name, setData } = props;

  if (
    entidade === "visitas" &&
    !props.roleKeycloack.includes(visitasFunc.visitaServVisualizar)
  ) {
    delete columns[1];
  }

  const history = useHistory();
  const [criancaId, setCriancaId] = useState("");
  const [dataNascimento, setDataNascimento] = useState("");
  const [nItens, setNItens] = useState(
    JSON.parse(sessionStorage.getItem(entidade + "-filter"))?.pageSize
  );

  const [loading, setLoading] = useState(false);

  const [shiftPressed] = useState(false);
  const [ordered, setOrdered] = useState([
    {
      id: "nome",
      desc: false,
    },
    {
      id: "pessoaFisicaCriancaResponse.nome",
      desc: false,
    },
    {
      id: "dataVisita",
      desc: true,
    },
  ]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    pageOptions,
    page,
    pageCount,
    prepareRow,
    canPreviousPage,
    canNextPage,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state,
    rows,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        filters: [],
        pageIndex: 0,
        sortBy: sessionStorage.getItem("table-criancas")
          ? JSON.parse(sessionStorage.getItem("table-criancas")).filter(
              (order) => order.desc !== undefined
            )
          : [
              {
                id: "nome",
                desc: false,
              },
              {
                id: "pessoaFisicaCriancaResponse.nome",
                desc: false,
              },
              {
                id: "dataVisita",
                desc: true,
              },
            ],
        pageSize: nItens,
      },
      manualPagination: entidade === "crianca" ? true : false,
      pageCount: JSON.parse(sessionStorage.getItem(entidade + "-filter"))
        ?.totalPages,
      roleKeycloack: props.roleKeycloack,
      user: props.user,
    },
    useFilters,
    useSortBy,
    usePagination,
    (hooks) => {
      if (entidade === "crianca") {
        hooks.visibleColumns.push((columns) => [
          ...columns,
          {
            id: "options",
            Header: "Opções",
            Cell: ({ row }) => {
              let temRiscoVida = false;

              if (
                row?.original?.movimentacoes[0]?.idMovimento === 1 ||
                row?.original?.movimentacoes[0]?.idMovimento === 6
              ) {
                const movimentacoes = row?.original?.movimentacoes || [];

                for (const mov of movimentacoes) {
                  if (mov?.idMovimento === 3 || !mov?.idMovimento) {
                    temRiscoVida = mov?.riscoVidaMotivoSituacao === "S";
                    break;
                  }
                }
              }

              return (
                <>
                  <Flex marginLeft="7px">
                    <Menu>
                      <MenuButton
                        as={IconButton}
                        icon={<BsThreeDots color="#fff" fontSize="20px" />}
                        variant={"link"}
                        cursor={"pointer"}
                        backgroundColor="#95BCBF"
                        color="#fff"
                        rounded={100}
                        p={2}
                      />
                      {(
                        row.original.movimentacoes
                          ? (row.original.movimentacoes[0]
                              ?.riscoVidaMotivoSituacao === "N" ||
                              !row.original.movimentacoes[0]
                                ?.riscoVidaMotivoSituacao) &&
                            !temRiscoVida
                          : false
                      ) ? (
                        <MenuList>
                          {props.roleKeycloack.includes(
                            servicoAcolhimentoFunc.visualizarPartePPCAAM
                          ) ||
                          props.roleKeycloack.includes(
                            criancaFunc.visualizar
                          ) ||
                          props.roleKeycloack.includes(
                            criancaFunc.visualizarTudo
                          ) ? (
                            <Link
                              as={ReactLink}
                              color={"#374BCE"}
                              _hover={{ textDecoration: "none" }}
                              to={"/crianca/" + row.original.id}
                            >
                              <MenuItem p={2}>
                                <BsEye />
                                <Text ml="5px">Visualizar</Text>
                              </MenuItem>
                            </Link>
                          ) : (
                            ""
                          )}
                          <Permission
                            roleKeycloack={props.roleKeycloack}
                            func={criancaFunc.imprimir}
                          >
                            <PrintMenuItemCrianca idCrianca={row.original.id} />
                          </Permission>
                          <Permission
                            roleKeycloack={props.roleKeycloack}
                            func={criancaFunc.editar}
                            id={
                              row.original?.servicoAcolhimento?.idPessoaJuridica
                            }
                            user={props?.user}
                            visualizar={true}
                          >
                            <Link
                              as={ReactLink}
                              color={"#374BCE"}
                              _hover={{ textDecoration: "none" }}
                              to={"/crianca/editar/" + row.original.id}
                            >
                              <MenuItem p={2}>
                                <FiEdit />
                                <Text ml="5px">Editar</Text>
                              </MenuItem>
                            </Link>
                          </Permission>

                          <Permission
                            roleKeycloack={props.roleKeycloack}
                            func={criancaFunc.desligar}
                          >
                            {row.original.movimentacoes[0]
                              ?.descricaoTipoSituacao === "Desligado" ||
                            (row.original.movimentacoes[0]
                              ?.descricaoTipoSituacao === "Acolhido" &&
                              row.original.movimentacoes[0]?.idMovimento ===
                                2) ? (
                              <Link
                                color={"#374BCE"}
                                _hover={{ textDecoration: "none" }}
                                onClick={() => {
                                  setCriancaId(row.original.id);
                                  setDataNascimento(
                                    row.original.dataNascimento
                                  );
                                  props.onOpenNovoAcolhimento();
                                }}
                              >
                                <MenuItem p={2}>
                                  <FiPlusCircle />
                                  <Text ml="5px">Novo Acolhimento</Text>
                                </MenuItem>
                              </Link>
                            ) : (
                              ""
                            )}
                          </Permission>
                          <Permission
                            roleKeycloack={props.roleKeycloack}
                            func={criancaFunc.excluir}
                          >
                            <Link
                              as={ReactLink}
                              color={"red"}
                              _hover={{ textDecoration: "none" }}
                              to={
                                "/crianca/" +
                                row.original.id +
                                `?excluir=${true}`
                              }
                            >
                              <MenuItem p={2}>
                                <CgClose />
                                <Text ml="5px">Excluir</Text>
                              </MenuItem>
                            </Link>
                          </Permission>
                        </MenuList>
                      ) : (
                        <MenuList>
                          {props.roleKeycloack.includes(
                            servicoAcolhimentoFunc.visualizarPartePPCAAM
                          ) ||
                          props.roleKeycloack.includes(
                            criancaFunc.visualizar
                          ) ||
                          props.roleKeycloack.includes(
                            criancaFunc.visualizarTudo
                          ) ? (
                            <Link
                              color={"#374BCE"}
                              _hover={{ textDecoration: "none" }}
                              onClick={() =>
                                riscoAlert(
                                  row.original.id,
                                  "visualizar",
                                  row.original?.servicoAcolhimento
                                    ?.idPessoaJuridica,
                                  row?.original?.movimentacoes[0]?.idMovimento
                                )
                              }
                            >
                              <MenuItem p={2}>
                                <BsEye />
                                <Text ml="5px">Visualizar</Text>
                              </MenuItem>
                            </Link>
                          ) : (
                            ""
                          )}
                          <Permission
                            roleKeycloack={props.roleKeycloack}
                            func={criancaFunc.editar}
                            id={
                              row.original?.servicoAcolhimento?.idPessoaJuridica
                            }
                            user={props?.user}
                            visualizar={true}
                          >
                            <Link
                              color={"#374BCE"}
                              _hover={{ textDecoration: "none" }}
                              onClick={() =>
                                riscoAlert(
                                  row.original.id,
                                  "editar",
                                  row.original?.servicoAcolhimento
                                    ?.idPessoaJuridica
                                )
                              }
                            >
                              <MenuItem p={2}>
                                <FiEdit />
                                <Text ml="5px">Editar</Text>
                              </MenuItem>
                            </Link>
                          </Permission>
                          <Permission
                            roleKeycloack={props.roleKeycloack}
                            func={criancaFunc.excluir}
                          >
                            <Link
                              as={ReactLink}
                              color={"red"}
                              _hover={{ textDecoration: "none" }}
                              to={
                                "/crianca/" +
                                row.original.id +
                                `?excluir=${true}`
                              }
                            >
                              <MenuItem p={2}>
                                <CgClose />
                                <Text ml="5px">Excluir</Text>
                              </MenuItem>
                            </Link>
                          </Permission>
                        </MenuList>
                      )}
                    </Menu>
                  </Flex>
                </>
              );
            },
          },
        ]);
      }
    }
  );

  useEffect(() => {
    if (entidade === "crianca") {
      const pageSize = JSON.parse(
        sessionStorage.getItem(entidade + "-filter")
      )?.pageSize;
      if (pageSize) {
        setNItens(pageSize);
      }
    } else {
      if (sessionStorage.getItem(entidade + "-pagination-count")) {
        setNItens(
          parseInt(sessionStorage.getItem(entidade + "-pagination-count"))
        );
      }
    }
  }, [entidade]);

  useEffect(() => {
    if (entidade === "crianca") {
      const storage = sessionStorage.getItem(entidade + "-filter");
      const tempPage = JSON.parse(storage)?.page;
      if (tempPage && tempPage <= pageCount) {
        gotoPage(tempPage);
      }
    } else {
      if (sessionStorage.getItem(entidade + "-pagination-page")) {
        const tempPage = Number(
          sessionStorage.getItem(entidade + "-pagination-page")
        );
        if (tempPage <= pageCount) {
          gotoPage(tempPage);
        }
      }
    }
  }, [state, entidade, gotoPage, pageCount]);

  const riscoAlert = (id, rota, idPJCrianca, idMovimento) => {
    if (
      idMovimento !== 2 &&
      !props.roleKeycloack.includes(criancaFunc.pesquisarRisco) &&
      !(
        (props.roleKeycloack.includes(criancaFunc.visualizarTudoAcolhimento) ||
          props.roleKeycloack.includes(criancaFunc.visualizarTudoTutelar)) &&
        props.user?.orgaoExterno?.includes(idPJCrianca)
      )
    ) {
      Swal.fire({
        title: "Por favor, entre em contato com o Gestor do MCA.",
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonColor: "#169499",
        cancelButtonText: "Voltar",
      });
    } else {
      if (rota === "visualizar") {
        history.push("/crianca/" + id);
      } else {
        history.push("/crianca/editar/" + id);
      }
    }
  };

  function irParaPagina(pagina) {
    if (entidade === "crianca") {
      setLoading(true);
      let tempObj = JSON.parse(sessionStorage.getItem(entidade + "-filter"));
      tempObj.page = pagina;
      sessionStorage.setItem(entidade + "-filter", JSON.stringify(tempObj));
      const storageValues = {
        nome: tempObj?.nome ? tempObj.nome : "",
        nomeExato: tempObj?.nomeExato.includes("Possui") ? true : false,
        nmFiliacao: tempObj?.nmFiliacao ? tempObj.nmFiliacao : "",
        tipoMotivo: tempObj?.tipoMotivo?.value ? tempObj.tipoMotivo.value : "",
        munSeacId: tempObj?.munSeacId?.id ? tempObj.munSeacId.id : "",
        idSeac: tempObj?.idSeac?.id ? tempObj.idSeac.id : "",
        pageSize: tempObj?.pageSize,
        page: pagina,
      };

      CriancaService.pesquisarCriancas(storageValues).then((res) => {
        sessionStorage.setItem(
          entidade + "-filter",
          JSON.stringify({
            ...tempObj,
            totalItems: res.data.totalElements,
            totalPages: res.data.totalPages,
          })
        );

        setData(res.data);
        setLoading(false);
      });
    } else {
      sessionStorage.setItem(entidade + "-pagination-page", pagina);
    }
    gotoPage(pagina);
  }

  function selecionarTotalItens(nItens) {
    sessionStorage.setItem(entidade + "-pagination-count", nItens);

    if (entidade === "crianca") {
      setLoading(true);
      let tempObj = JSON.parse(sessionStorage.getItem(entidade + "-filter"));
      tempObj.page = 0;
      tempObj.pageSize = nItens;
      const storageValues = {
        nome: tempObj?.nome ? tempObj.nome : "",
        nomeExato: tempObj?.nomeExato.includes("Possui") ? true : false,
        nmFiliacao: tempObj?.nmFiliacao ? tempObj.nmFiliacao : "",
        tipoMotivo: tempObj?.tipoMotivo?.value ? tempObj.tipoMotivo.value : "",
        munSeacId: tempObj?.munSeacId?.id ? tempObj.munSeacId.id : "",
        idSeac: tempObj?.idSeac?.id ? tempObj.idSeac.id : "",
        pageSize: nItens,
        page: tempObj?.page,
      };

      CriancaService.pesquisarCriancas(storageValues).then((res) => {
        sessionStorage.setItem(
          entidade + "-filter",
          JSON.stringify({
            ...tempObj,
            totalItems: res.data.totalElements,
            totalPages: res.data.totalPages,
          })
        );

        setData(res.data);
        setLoading(false);
      });
    }
    setPageSize(nItens);
  }

  const handleSortingPersistence = (column) => {
    const hasOrdered = ordered.find((order) => order.id === column.id);
    let sortedDesc;
    const tempOrdered = [];

    if (!shiftPressed) {
      sessionStorage.removeItem("tabela-cadastros");
    }

    if (!shiftPressed && ordered.length > 1 && !column.isSortedDesc) {
      sortedDesc = column.isSortedDesc;
    } else {
      switch (column.isSortedDesc) {
        case true:
          sortedDesc = undefined;
          break;
        case false:
          sortedDesc = true;
          break;
        default:
          sortedDesc = false;
          break;
      }
    }

    if (shiftPressed) {
      if (hasOrdered) {
        tempOrdered.push(
          ...ordered.map((order) => {
            if (order.id === column.id) {
              return { id: column.id, desc: sortedDesc };
            } else {
              return order;
            }
          })
        );
        setOrdered(tempOrdered);
      } else {
        tempOrdered.push(...ordered);
        tempOrdered.push({ id: column.id, desc: sortedDesc });
        setOrdered(tempOrdered);
      }
    } else {
      tempOrdered.push({ id: column.id, desc: sortedDesc });
      setOrdered(tempOrdered);
    }

    sessionStorage.setItem("table-criancas", JSON.stringify(tempOrdered));
  };

  return (
    <Flex flexDir="column" w="100%">
      <Flex flexDir="column" width="100%" mt="20px" h="100%">
        <Flex w={"100%"} flexDir={"column"}>
          {isEmptyArray(data) ? (
            <SemRegistros
              loading={loading}
              entidade={entidade}
              half
              crianca={true}
              data={data}
              name={name}
            />
          ) : (
            <>
              <CadastrarMovimentacaoModal
                isOpen={props.isOpenNovoAcolhimento}
                onOpen={props.onOpenNovoAcolhimento}
                data={data}
                onOpenNovoAcolhimento={props.onOpenNovoAcolhimento}
                movimentoDefault={true}
                idCrianca={criancaId}
                table={true}
                tableCrianca={true}
                dataNascimento={dataNascimento}
                atualizarDados={props.setAtualizarDadosTabela}
                onClose={() => {
                  props.onCloseNovoAcolhimento();
                }}
                roleKeycloack={props.roleKeycloack}
                user={props.user}
                idPJ={props.idPJ}
              />

              <Permission
                roleKeycloack={props.roleKeycloack}
                func={entidade === "visitas" ? visitasFunc.visitaConsultar : ""}
              >
                <Flex flexDir={"column"}>
                  <Flex overflowX="auto" pb={5}>
                    <Table {...getTableProps} backgroundColor="white">
                      <Thead backgroundColor="#ECEFF1">
                        {headerGroups.map((headerGroup, index) => (
                          <Tr
                            {...headerGroup.getHeaderGroupProps()}
                            key={index}
                          >
                            {headerGroup.headers.map((column, index) => (
                              <Th
                                {...column.getHeaderProps(
                                  column.getSortByToggleProps({
                                    title: undefined,
                                  })
                                )}
                                key={index}
                                p="0px"
                              >
                                <Flex
                                  flexDir="row"
                                  alignContent="center"
                                  px="24px"
                                  py="12px"
                                  onClick={
                                    column.Header !== "Opções"
                                      ? () => {
                                          handleSortingPersistence(column);
                                        }
                                      : null
                                  }
                                >
                                  <Text as="p">{column.render("Header")}</Text>

                                  {column.Header !== "Opções" ? (
                                    <Flex pl={1} alignItems="center">
                                      {column.isSorted ? (
                                        column.isSortedDesc ? (
                                          <Icon
                                            as={FaSortDown}
                                            boxSize="14px"
                                          />
                                        ) : (
                                          <Icon as={FaSortUp} boxSize="14px" />
                                        )
                                      ) : (
                                        <Icon as={FaSort} boxSize="14px" />
                                      )}
                                    </Flex>
                                  ) : (
                                    ""
                                  )}
                                </Flex>
                              </Th>
                            ))}
                          </Tr>
                        ))}
                      </Thead>
                      {loading ? (
                        <Tbody>
                          <Tr>
                            <Td colSpan={5} textAlign="center">
                              <LoadingSpinner />
                            </Td>
                          </Tr>
                        </Tbody>
                      ) : (
                        <>
                          <Tbody {...getTableBodyProps}>
                            {page.map((row, i) => {
                              prepareRow(row);

                              return (
                                <Tr {...row.getRowProps()} key={i}>
                                  {row.cells.map((cell, index) => {
                                    return (
                                      <Td
                                        py="6px"
                                        fontWeight={400}
                                        fontSize="13px"
                                        lineHeight="21.6px"
                                        {...cell.getCellProps()}
                                        key={index}
                                      >
                                        {cell.render("Cell")}
                                      </Td>
                                    );
                                  })}
                                </Tr>
                              );
                            })}
                          </Tbody>
                        </>
                      )}
                    </Table>
                  </Flex>

                  {entidade === "crianca" && (
                    <Flex gap={10} mt="2">
                      <Flex alignItems="center" gap={1}>
                        <Box
                          w="4"
                          h="4"
                          bg="#169499"
                          borderRadius="full"
                          border="1px"
                          color="#169499"
                        />
                        <Text>Em Transferência</Text>
                      </Flex>
                      <Flex alignItems="center" gap={1}>
                        <Box
                          w="4"
                          h="4"
                          bg="red"
                          borderRadius="full"
                          border="1px"
                          color="red"
                        />
                        <Text>Pendência por Maioridade</Text>
                      </Flex>
                    </Flex>
                  )}
                  <TablePagination
                    nItens={nItens}
                    selecionarTotalItens={selecionarTotalItens}
                    irParaPagina={irParaPagina}
                    pageSize={state.pageSize}
                    setPageSize={setPageSize}
                    rows={rows}
                    totalItems={
                      JSON.parse(sessionStorage.getItem(entidade + "-filter"))
                        ?.totalItems
                    }
                    gotoPage={gotoPage}
                    canPreviousPage={canPreviousPage}
                    previousPage={previousPage}
                    pageOptions={pageOptions}
                    pageIndex={state.pageIndex}
                    canNextPage={canNextPage}
                    nextPage={nextPage}
                    pageCount={pageCount}
                    entidade={entidade}
                    loading={loading}
                  />
                </Flex>
              </Permission>
            </>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};
